import { STATUS_LABEL, CMD_LABEL } from "@/lib/api";

const STYLE = {
  conectado: "text-cyan-300 border-cyan-400/50 bg-cyan-950/40",
  confirmada: "text-cyan-300 border-cyan-400/50 bg-cyan-950/40",
  desconectado: "text-slate-400 border-slate-600 bg-slate-900",
  pendiente: "text-amber-300 border-amber-500/40 bg-amber-950/30",
  reclamada: "text-sky-300 border-sky-500/40 bg-sky-950/30",
  ejecutando: "text-sky-300 border-sky-500/40 bg-sky-950/30",
  error: "text-red-400 border-red-500/50 bg-red-950/30",
  fallida: "text-red-400 border-red-500/50 bg-red-950/30",
  incierta: "text-orange-300 border-orange-500/50 bg-orange-950/30",
  cancelada: "text-slate-400 border-slate-600 bg-slate-900",
  vencida: "text-slate-400 border-slate-600 bg-slate-900",
  desconocido: "text-slate-400 border-slate-700 bg-slate-900",
};

export function StatusBadge({ status, testId }) {
  const label = STATUS_LABEL[status] || CMD_LABEL[status] || status;
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1.5 border px-2 py-0.5 text-[10px] uppercase tracking-[0.18em] font-ui font-semibold ${STYLE[status] || STYLE.desconocido}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${status === "conectado" || status === "confirmada" ? "bg-cyan-300 animate-pulse" : "bg-current opacity-70"}`} />
      {label}
    </span>
  );
}
